// declare global {
//   interface Window {
//     gtag: Gtag.Gtag;
//   }
// }

declare global {
  interface Window {
    dataLayer: Array<Object>;
  }
}

// export function initializeGA(measurementId: string) {
//   const script = document.createElement('script')
//   script.text = `window.dataLayer = window.dataLayer || [];
//     function gtag(){dataLayer.push(arguments);}
//     gtag('js', new Date());
//     gtag('config', '${measurementId}');`

//   document.body.appendChild(script)
// }

export const sendEvent = (
  eventAction: string,
  eventCategory: string,
  eventLabel?: string,
  value?: number,
) => {
  // gtag('event', eventAction, {
  //   category: eventCategory,
  //   label: eventLabel, // optional
  //   value: value, // optional, must be a number
  // });

  // 呼び出し方
  // GTMのデータレイヤーの変数を設定する
  // ga.sendEvent("samepleEvent", "sampleCategory");

  window.dataLayer.push({
    event: eventAction,
    eventCategory,
    eventLabel,
    value,
  });
}

// export const sendException = (errorMessage: string) => {
//   const params = {
//     description: errorMessage,
//     fatal: true,
//   }

//   gtag('event', 'exception', params)
// }
